import { useEffect } from "react";
import { Navbar } from "../components/Navbar";
import { Hero } from "../components/Hero";
import { Marquee, Services, WhyChoose, About, Industries, Process, Certifications, Testimonials, TrustBar } from "../components/Sections";
import { ContactForm } from "../components/ContactForm";
import { Footer } from "../components/Footer";
import { MobileStickyCTA } from "../components/MobileStickyCTA";
import { useLenis } from "../lib/useLenis";

export default function Landing() {
  useLenis();
  useEffect(() => {
    document.title = "Wilson Courier Solutions | Medical & Business Courier Atlanta";
  }, []);
  return (
    <div className="App bg-white pb-16 lg:pb-0" data-testid="landing-page">
      <Navbar />
      <Hero />
      <TrustBar />
      <Marquee />
      <Services />
      <WhyChoose />
      <About />
      <Industries />
      <Process />
      <Certifications />
      <Testimonials />
      <ContactForm />
      <Footer />
      <MobileStickyCTA />
    </div>
  );
}
